module.exports = __webpack_public_path__ + "img/s5ForStar_350x350.39c993ed.jpg";